import React from 'react';
import { Link } from 'react-router-dom';
import ArrowIcon from '../../common/svg/ArrowIcon';
import { SOCIAL_LINKS } from '../../constants/ContactsConstant';
import { Blog } from '../../types/CommonTypes';

type BlogGridProps = {
  blogs: Blog[];
  gridClass?: string;
  limit?: number;
};

const BlogGrid: React.FC<BlogGridProps> = ({
  blogs,
  gridClass = 'col-lg-4',
  limit,
}) => {
  const blogsToShow = limit ? blogs.slice(0, limit) : blogs;

  return (
    <div className='row g-lg-4 gy-5'>
      {blogsToShow.map(
        ({
          id,
          animationClass,
          delay,
          cardImage,
          tag,
          title,
          publishedDate,
        }) => (
          <div
            key={id}
            className={`${gridClass} col-md-6 wow animate__animated ${animationClass}`}
            data-wow-delay={delay}
            data-wow-duration='1500ms'
          >
            <div className='single-blog magnetic-item'>
              <div className='blog-img'>
                <img className='img-fluid' src={cardImage} alt='Banner image' />
                <div className='blog-tag'>
                  <Link to={`/blogs/${id}`}> {tag} </Link>
                </div>
              </div>
              <div className='blog-content'>
                <ul className='blog-meta'>
                  <li>
                    <Link to={`/blogs/${id}`}> {publishedDate} </Link>
                  </li>
                </ul>
                <h4>
                  <Link to={`/blogs/${id}`}>
                    {title.length > 44 ? title.substring(0, 44) + '...' : title}
                  </Link>
                </h4>
                <div className='blog-footer'>
                  <div className='read-btn'>
                    <Link to={`/blogs/${id}`}>
                      Read More
                      <ArrowIcon />
                    </Link>
                  </div>
                  {/* <div className="social-area">
                    <ul>
                      {SOCIAL_LINKS.map(({ icon, url }) => (
                        <li key={url}>
                          <Link
                            to={url}
                            target="_blank"
                            rel="noopener noreferrer">
                            <i className={icon}></i>
                          </Link>
                        </li>
                      ))}
                    </ul>
                    <span>
                      <img
                        src="https://appthing-website.s3.ap-south-1.amazonaws.com/plain-icon.svg"
                        alt=""
                      />
                    </span>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        ),
      )}
    </div>
  );
};

export default BlogGrid;
